export function convertFileToFormData(file: File, name = 'file'): FormData {
  const formData = new FormData();
  formData.append(name, file);

  return formData;
}
